import { cn } from '@ui/lib/utils';
import * as React from 'react';
import {
  inputVariants,
  inputWrapperVariants,
} from '@ui/components/variants/inputVariants';
import type { VariantProps } from 'class-variance-authority';

export interface InputProps
  extends
    React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputWrapperVariants> {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  hasError?: boolean;
  wrapperClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      variant,
      inputSize,
      type,
      leftIcon,
      rightIcon,
      hasError,
      wrapperClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn(
          inputWrapperVariants({
            variant,
            inputSize,
            className: wrapperClassName,
            isError: hasError,
          })
        )}
      >
        {leftIcon}
        <input
          type={type}
          ref={ref}
          className={cn(
            inputVariants({
              inputSize,
              className,
            })
          )}
          {...props}
        />
        {rightIcon}
      </div>
    );
  }
);
Input.displayName = 'Input';

export interface TextAreaProps
  extends
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof inputWrapperVariants> {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  hasError?: boolean;
  wrapperClassName?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      className,
      variant,
      inputSize,
      leftIcon,
      rightIcon,
      hasError,
      wrapperClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn(
          inputWrapperVariants({
            variant,
            inputSize,
            className: wrapperClassName,
            isError: hasError,
          })
        )}
      >
        {leftIcon}
        <textarea
          ref={ref}
          className={cn(
            inputVariants({
              inputSize,
              className,
            }),
            'max-h-[500px] min-h-[72px]'
          )}
          {...props}
        />
        {rightIcon}
      </div>
    );
  }
);
TextArea.displayName = 'TextArea';

export { Input, TextArea };
